<!-- Commercial Invoice Format -->
<div class="commercial-invoice-container">
  <div class="invoice-page" *ngFor="let invoice of editableInvoices; let i = index">

    <!-- Header Section -->
    <!-- <div class="invoice-header">
      <div class="header-left">
        <div class="outputs-section">
          <span class="outputs-label">Outputs</span>
        </div>
        <div class="comm-invoice-button">
          <button class="btn-comm-invoice">COMM. INVOICE</button>
        </div>
      </div>

      <div class="header-right">
        <button class="print-all-btn">Print All</button>
      </div>
    </div> -->

    <!-- Main Content Area -->
    <div class="main-content">

      <!-- Address and Date Section -->
      <div class="address-date-section">
        <div class="address-section">
          <div class="address-row">
            <span class="label">ADDRESS</span>
          </div>
          <div class="address-row">
            <span class="label">PHONE</span>
            <span class="value">+81-78-201-5360</span>
          </div>
          <div class="address-row">
            <span class="label">BUYER</span>
            <span class="value">{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</span>
          </div>
          <div class="address-row">
            <span class="label">ADDRESS</span>
            <span class="value">{{ invoice.order?.buyer_street_address }}, {{ invoice.order?.buyer_city }}, {{ invoice.order?.buyer_country }}</span>
          </div>
        </div>

        <div class="invoice-title-section">
          <h1 class="commercial-invoice-title">COMMERCIAL INVOICE</h1>
          <div class="port-info">
            <div class="port-row">
              <span class="port-label">PORT OF LOADING</span>
              <span class="port-value">ANY PORT IN JAPAN</span>
            </div>
            <div class="port-row">
              <span class="port-label">PORT OF DISCHARGE</span>
              <span class="port-value">{{ invoice.order?.to_port }}, {{ invoice.order?.to_country }}</span>
            </div>
            <div class="port-row">
              <span class="port-label">VESSEL</span>
              <span class="port-value">{{ invoice.ship_name || 'ON OR ABOUT' }}</span>
            </div>
          </div>
        </div>

        <div class="date-section">
          <div class="date-row">
            <span class="date-label">DATE</span>
            <span class="date-value">{{ formatDate(invoice.invoice_date) }}</span>
          </div>
          <div class="date-row">
            <span class="date-label">INVOICE NO</span>
            <span class="date-value">{{ invoice.invoice_number }}</span>
          </div>
        </div>
      </div>

      <!-- Goods Description Table -->
      <div class="goods-table-section">
        <table class="goods-table">
          <thead>
            <tr>
              <th class="marks-column">MARKS AND NUMBERS</th>
              <th class="description-column">DESCRIPTION OF GOODS</th>
              <th class="quantity-column">QUANTITY</th>
              <th class="price-column">{{invoice.order.ship_type}} {{invoice?.ship?.destination_port}}</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loop through vehicles - Static data for now -->
            <tr class="main-row" *ngFor="let vehicle of invoice.editableVehicles; let idx = index">
              <!-- Column 1: Marks and Numbers -->
              <td class="marks-cell">
                <div class="marks-content">
                  FAX +81-78-291-5374 MADE IN JAPAN
                </div>
              </td>

              <!-- Column 2: Description of Goods -->
              <td class="description-cell">
                <div class="description-content">
                  <!-- Input box at top -->
                  <div class="description-input-box">
                    {{ vehicle.car_no }}
                  </div>

                  <!-- Vehicle details in two-column layout -->
                  <div class="vehicle-details">
                    <div class="detail-row">
                      <span class="detail-label">MAKE / MODEL</span>
                      <span class="detail-value">{{ vehicle.company_name }} / {{ vehicle.name }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">TYPE OF VEHICLE</span>
                      <span class="detail-value">{{ vehicle.type }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">CHASSIS NO</span>
                      <span class="detail-value">{{ vehicle.vin_no }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">YEAR OF MANUFACTURE</span>
                      <span class="detail-value">{{ vehicle.year }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">DATE OF FIRST REGISTRATION</span>
                      <span class="detail-value">{{ vehicle.year }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">BODY COLOR</span>
                      <span class="detail-value">{{ vehicle.color }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">HS CODE</span>
                      <span class="detail-value">{{ vehicle.hsCode }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">STEERING</span>
                      <span class="detail-value">{{ vehicle.steering }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">FUEL</span>
                      <span class="detail-value">{{ vehicle.fuel_type }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">EXPORT CERTIFICATE NUMBER</span>
                      <span class="detail-value">{{ vehicle.export_certificate_no }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">INSTALLED ACCESSORIES</span>
                      <span class="detail-value accessories-box"></span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">COUNTRY OF ORIGIN</span>
                      <span class="detail-value">-</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">OCEAN FREIGHT</span>
                      <span class="detail-value"></span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">INSURANCE</span>
                      <span class="detail-value"></span>
                    </div>
                  </div>
                </div>
              </td>

              <!-- Column 3: Quantity -->
              <td class="quantity-cell">
                <div class="quantity-content">
                  <div class="quantity-value">1</div>
                  <!-- <div class="fob-section">
                    <div class="fob-label">(FOB JAPAN)</div>
                    <div class="fob-value">{{ invoice.invoice_amount }}</div>
                  </div> -->
                </div>
              </td>

              <!-- Column 4: C&F Price -->
              <td class="price-cell">
                <div class="price-content">
                  <div class="price-value">
                    <input type="number" class="form-control form-control-sm"
                      [(ngModel)]="vehicle.editableInvoiceAmount"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="price-spacer"></div>
                  <div class="price-bottom-inputs">
                    <div class="price-freight-input">
                      <input type="number" class="form-control form-control-sm"
                        [(ngModel)]="vehicle.editableOceanFreight"
                        (ngModelChange)="onFieldChange()">
                    </div>
                    <div class="price-insurance-input">
                      <input type="number" class="form-control form-control-sm"
                        [(ngModel)]="vehicle.editableInsurance"
                        (ngModelChange)="onFieldChange()">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Total Section -->
      <div class="total-section">
        <div class="total-row">
          <div class="total-label-section">
            <span class="total-label">TOTAL {{ getTotalQuantity() }} UNIT{{ getTotalQuantity() > 1 ? 'S' : '' }}</span>
          </div>
          <div class="total-value-section">
            <span class="incoterm-label">INCOTERM 2010 {{invoice.ship?.destination_port}} {{invoice.ship?.destination_country}}</span>
          </div>
          <div class="total-amount-section">
            <span class="total-amount">{{ getTotalAmount() }}</span>
          </div>
        </div>
      </div>

      <!-- Certification Section -->
      <div class="certification-section">
        <div class="cert-left">
          <p>WE HEREBY CERTIFY THAT THE SHIPMENT IS CONFORMITY WITH PROFORMA INVOICE</p>
        </div>
        <div class="cert-center">
          <span class="proforma-number">{{ invoice.order?.order_number }}</span>
        </div>
        <div class="cert-right">
          <span class="cert-date">DATED: {{ formatDate(invoice.order?.order_date || null) }}</span>
        </div>
      </div>

      <!-- Documentary Credit Section -->
      <div class="documentary-section">
        <div class="doc-left">
          <div class="doc-row">
            <span class="doc-label">DOCUMENTARY CREDIT NO:</span>
          </div>
          <div class="doc-row">
            <span class="doc-label">DATE OF ISSUE: {{ getCurrentDate() }}</span>
          </div>
          <div class="doc-row">
            <span class="doc-label">ISSUED BY:</span>
          </div>
        </div>

        <div class="doc-right">
          <div class="signature-area">
            <div class="imperial-stamp">
              <div class="stamp-text">SUPREME<br>MOTORS</div>
            </div>
            <div class="signature-line">
              <p class="auth-signature">AUTHORIZED SIGNATURE</p>
              <p class="company-name">Supreme Motors</p>
              <p class="signatory-name">D.S SETHI</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms of Trade Section -->
    <!-- <div class="terms-section">
      <h4 class="terms-title">TERMS OF TRADE</h4>
      <div class="terms-content">
        <div class="terms-grid">
          <div class="term-item">
            <span class="term-number">1.</span>
            <span class="term-text">Shipment deposit for the units bought from Auction or Stock must be paid within 15 days from purchase date. If the shipping deposit amount is not paid within 15 days, then any money transaction accounted to Imperial Solutions Limited account shall be assigned to the above unit first without exception even if those payments were sent to complete balance on already arrived units at the destination port.</span>
          </div>

          <div class="term-item">
            <span class="term-number">2.</span>
            <span class="term-text">Imperial Solutions Limited may not surrender or release BILL for any unit based on TT Scan. ISL may only surrender or release based on the remittance confirmation at our bank.</span>
          </div>

          <div class="term-item">
            <span class="term-number">3.</span>
            <span class="term-text">Customer needs to pay the balance before or within 14 days of arrival at port or a daily penalty of 1,000 JPY per day will be charged until the balance within 30 days of arrival date or no communication gives I.S.L the rights to re-sale your vehicle to another buyer with any occupation losses to be recovered from your deposit.</span>
          </div>

          <div class="term-item">
            <span class="term-number">4.</span>
            <span class="term-text">All units subjected to shipping on 30% or 50% deposit shall only be shipped through C&F (Caribbean Auto Terminal) Only. You can request shipment on the consignee of your choice if you have sent the full 100% payment before shipment.</span>
          </div>

          <div class="term-item">
            <span class="term-number">5.</span>
            <span class="term-text">A minimum deposit of 1,500 USD or 150,000 JPY will be charged for any unit bought from auction. Any unit whose C&F amount is more than 6,500 USD, the minimum deposit will be 3,000 USD or 300,000 JPY for auction sales. For Luxury Vehicles, Heavy machinery or Commercial Vehicles, the minimum deposit will be 50% of the C&F amount.</span>
          </div>

          <div class="term-item">
            <span class="term-number">6.</span>
            <span class="term-text">Ready Stock units can be released without minimum deposit, customer must pay the shipping deposit within 2 days' time to confirm the unit to his account. After 7 days, the reservation will be over and the unit might be sold to the next waiting customer.</span>
          </div>

          <div class="term-item">
            <span class="term-number">7.</span>
            <span class="term-text">All banking charges should be borne by the customer. Any cancellation of the purchased unit must be notified at least 14 days prior to departure date. Cancellation Penalty shall be charged 10% of the total C&F for units under 10,000 USD. C&F plus yard fee of the vehicle held time span and any extra costs/penalty requested prior to the cancellation. In case of cancellation of already shipped units, 100% of the C&F amount will be charged.</span>
          </div>

          <div class="term-item">
            <span class="term-number">8.</span>
            <span class="term-text">For any inquiry regarding the purchased unit, please contact <strong>johnyk_details.php</strong> Imperial Solutions Ltd. will not be liable for any payments made in any accounts not listed in our website.</span>
          </div>

          <div class="term-item">
            <span class="term-number">9.</span>
            <span class="term-text">All official emails from ISL Japan will always be from domain @imperialsolutions.jp, for example abc123@imperialsolutions.jp Any email you receive claiming to be from Imperial Solutions Japan and does not match this official domain, please disregard it and report to Imperial Solutions Japan Limited. ISL will not be responsible for any communication or result of loss from non-official domain emails impersonating ISL.</span>
          </div>

          <div class="term-item">
            <span class="term-number">5.</span>
            <span class="term-text">A minimum deposit of 1,500 USD or 150,000 JPY will be charged for any unit bought from auction. Any unit whose C&F amount is more than 6,500 USD, the minimum deposit will be 3,000 USD or 300,000 JPY for auction sales. For Luxury Vehicles, Heavy machinery or Commercial Vehicles, the minimum deposit will be 50% of the C&F amount.</span>
          </div>

          <div class="term-item">
            <span class="term-number">6.</span>
            <span class="term-text">Ready Stock units can be released without minimum deposit, customer must pay the shipping deposit within 2 days' time to confirm the unit to his account. After 7 days, the reservation will be over and the unit might be sold to the next waiting customer.</span>
          </div>

          <div class="term-item">
            <span class="term-number">7.</span>
            <span class="term-text">All banking charges should be borne by the customer. Any cancellation of the purchased unit must be notified at least 14 days prior to departure date. Cancellation Penalty shall be charged 10% of the total C&F for units under 10,000 USD. C&F plus yard fee of the vehicle held time span and any extra costs/penalty requested prior to the cancellation. In case of cancellation of already shipped units, 100% of the C&F amount will be charged.</span>
          </div>

          <div class="term-item">
            <span class="term-number">8.</span>
            <span class="term-text">For any inquiry regarding the purchased unit, please contact <strong>johnyk_details.php</strong> Imperial Solutions Ltd. will not be liable for any payments made in any accounts not listed in our website.</span>
          </div>

          <div class="term-item">
            <span class="term-number">9.</span>
            <span class="term-text">All official emails from ISL Japan will always be from domain @imperialsolutions.jp, for example abc123@imperialsolutions.jp Any email you receive claiming to be from Imperial Solutions Japan and does not match this official domain, please disregard it and report to Imperial Solutions Japan Limited. ISL will not be responsible for any communication or result of loss from non-official domain emails impersonating ISL.</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Page Break (except for last invoice) -->
    <!-- <div class="page-break" *ngIf="i < invoices.length - 1"></div> -->

  </div>
</div>
